export const setUserActivities = (data) => {
    return {
        type: "SET_USER_ACTIVITIES",
        payload: data,
    };
};

export const setUser = (data) => {
    return {
        type: "SET_USER",
        payload: data,
    };
};

export const setTitle = (data) => {
    return {
        type: "SET_TITLE",
        payload: data,
    };
};

export const setLocation = (data) => {
    return {
        type: "SET_LOCATION",
        payload: data,
    };
};

export const setMessage = (data) => {
    return {
        type: "SET_MESSAGE",
        payload: data,
    };
};

export const setElevation = (data) => {
    return {
        type: "SET_ELEVATION",
        payload: data,
    };
};

export const setSmallText = (data) => {
    return {
        type: "SET_SMALL_TEXT",
        payload: data,
    };
};

export const setGeoJson = (data) => {
    return {
        type: "SET_GEO_JSON",
        payload: data,
    };
};

export const setOrderId = (data) => {
    return {
        type: "SET_ORDER_ID",
        payload: data,
    };
};

export const setStyle = (data) => {
    return {
        type: "SET_STYLE",
        payload: data,
    };
};

export const setShowElevation = (data) => {
    return {
        type: "SET_SHOW_ELEVATION",
        payload: data,
    };
};

export const setShowStartStop = (data) => {
    return {
        type: "SET_SHOW_START_STOP",
        payload: data,
    };
};

export const setCanvasSize = (data) => {
    return {
        type: "SET_CANVAS_SIZE",
        payload: data,
    };
};

export const setStravaJson = (data) => {
    return {
        type: "SET_STRAVA_JSON",
        payload: data,
    };
};

export const setMarkersJson = (data) => {
    return {
        type: "SET_MARKERS_JSON",
        payload: data,
    };
};

export const setZoom = (data) => {
    return {
        type: "SET_ZOOM",
        payload: data,
    };
};

export const loadOrder = (data) => {
    return {
        type: "LOAD_ORDER",
        payload: data,
    };
};

export const setMarkersWithText = (data) => {
    return {
        type: "SET_MARKERS_WITH_TEXT",
        payload: data,
    };
};

export const setGpxArray = (data) => {
    return {
        type: "SET_GPX_ARRAY",
        payload: data,
    };
};
